
import { mapActions, mapMutations } from 'vuex'
export default {
  auth: false,
  async fetch() {
    const res = await this.getPackages()
    console.log('pricing', res)
    res.pricePerUnit.map(el => (el['row-class'] = 'item-class-row'))
    //res.monthlySubscription.map(el => (el['row-class'] = 'item-class-row'))
    res.addOns.map(el => (el['row-class'] = 'item-class-row'))
    this.packageItem = res.pricePerUnit
    //this.packageItem1 = res.monthlySubscription
    this.packageItem2 = res.addOns
    // if (this.packageItem) {
    //   this.packageItem.map(
    //     el => (el.price = this.$options.filters.priceDecim(el.price))
    //   )
    // }
    // if (this.packageItem1) {
    //   this.packageItem1.map(
    //     el => (el.price = this.$options.filters.priceDecim(el.price))
    //   )
    // }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('Unit(s)'),
          align: 'center',
          value: 'unit',
          sortable: false,
          class: 'table-header-class',
          itemClass: 'item-class-row',
        },
        {
          text: this.$t('Price (baht)/Unit'),
          value: 'price',
          align: 'center',
          sortable: false,
          class: 'table-header-class',
        },
        {
          text: this.$t('Start Package'),
          value: 'actions',
          align: 'center',
          sortable: false,
          class: 'table-header-class',
        },
      ],
      packageItem: [],
      headers1: [
        {
          text: this.$t('Unit'),
          align: 'center',
          value: 'unit',
          sortable: false,
          class: 'table-header-class',
        },
        {
          text: this.$t('Price  (baht)'),
          value: 'price',
          align: 'center',
          sortable: false,
          class: 'table-header-class',
        },
        {
          text: this.$t('Start Package'),
          value: 'actions',
          align: 'center',
          sortable: false,
          class: 'table-header-class',
        },
      ],
      packageItem1: [],
      headers2: [
        {
          text: this.$t('Description'),
          align: 'center',
          value: 'unit',
          sortable: false,
          class: 'table-header-class',
          itemClass: 'item-class-row',
        },
        {
          text: this.$t('Price  (baht)'),
          value: 'price',
          align: 'center',
          sortable: false,
          class: 'table-header-class',
        },
        {
          text: this.$t('Package'),
          value: 'actions',
          align: 'center',
          sortable: false,
          class: 'table-header-class',
        },
      ],
      packageItem2: [],
      showSchedule: false,
      addonSelected: false,
    }
  },
  created() {
    // this.initialize()
  },
  mounted() {
    this.$on('showSchedule', event => {
      console.log(event)
      this.showSchedule = false
    })
  },
  computed: {
    disabledMenus() {
      if (process.browser) {
        return (
          window.location.origin === 'https://properlly.com' ||
          window.location.origin === 'https://www.properlly.com' ||
          window.location.origin === 'https://properlly.co.th' ||
          window.location.origin === 'https://www.properlly.co.th'
        )
      } else {
        return false
      }
    },
  },
  methods: {
    ...mapActions('config/site', ['setTypeOfLoginwant']),
    ...mapMutations('config/site', ['setLogInDialogShow', 'setScheduleShow']),
    ...mapActions('packages', ['getPackages']),
    openDialog(type) {
      // this.closeDrawer()
      this.setScheduleShow({ demo: true, visit: false })
    },
    initialize() {
      this.packageItem = [
        {
          name: this.$t('One Unit'),
          price: this.$t('1,000 Baht/Mo'),
          'row-class': 'item-class-row',
          id: 1,
        },
        {
          name: this.$t('2 to 10 units'),
          price: this.$t('950 Baht/Mo/Unit'),
          'row-class': 'item-class-row',
          id: 2,
        },
        {
          name: this.$t('11 to 25 units'),
          price: this.$t('900 Baht/Mo/Unit'),
          'row-class': 'item-class-row',
          id: 3,
        },
      ]
      this.packageItem1 = [
        {
          name: this.$t('26 – 100 units'),
          price: this.$t('25,000 Baht/mo'),
          'row-class': 'item-class-row',
          id: 4,
        },
        {
          name: this.$t('101+ units'),
          price: this.$t('50,000 Baht/mo'),
          'row-class': 'item-class-row',
          id: 5,
        },
      ]
    },
    select(item) {
      console.log(this.packageItem)
      console.log(item.id)
      console.log(this.$auth.loggedIn)
      if (this.$auth.loggedIn && item.id) {
        this.$router.push({
          path: `/payment/${item.id}?addons=${this.addonSelected}`,
        })
      } else {
        this.setTypeOfLoginwant({ typeOfLogin: 2 }).then(data => {
          this.setLogInDialogShow(true)
        })
      }
    },
  },
}
